import React, { ReactElement } from "react";
import { EuiSpacer, EuiTitle, EuiTitleSize } from "@elastic/eui";
import { SpacerSize } from "@elastic/eui/src/components/spacer/spacer";

export interface IFDTitleProps {
  addHorizontalRule?: boolean;
  align?: string;
  bottomSpaceSize?: SpacerSize;
  className?: string;
  color?: string;
  hasBorder?: boolean;
  popoverColumns?: any[];
  popoverData?: any[];
  popoverSortDirection?: string;
  popoverSortField?: string;
  showBottomSpace?: boolean;
  title: string | ReactElement | undefined;
  titleSize?: EuiTitleSize;
  weight?: number;
  wrap?: boolean;
  style?: any;
}

export const FDTitle = React.memo<IFDTitleProps>(
  ({
    titleSize = "xs",
    title,
    bottomSpaceSize = "m",
    className = undefined,
    wrap = true,
    showBottomSpace = true,
    color = null,
    weight,
    align,
    style = {},
  }) => {
    const titleStyle: any = {
      whiteSpace: "nowrap",
      ...style,
    };

    if (!title) return null;
    if (wrap) delete titleStyle.whiteSpace;
    if (color) titleStyle.color = color;
    if (weight) titleStyle.fontWeight = weight;
    if (align) titleStyle.textAlign = align;

    const t = (
      <EuiTitle className={className} size={titleSize}>
        <h4 style={titleStyle}>{title}</h4>
      </EuiTitle>
    );

    return (
      <>
        {t}
        {showBottomSpace && <EuiSpacer size={bottomSpaceSize} />}
      </>
    );
  }
);
